import AHMIS, { API_URL } from "../../api/api";

export const fetchPendingNotifications = async (targetRegister) => {
  try {
    const response = await AHMIS.get(`${API_URL.notifications}/pending?targetRegister=${targetRegister}`);
    const data = response.data || {};
    return {
      totalSize: data.totalSize || 0,
      objectList: data.objectList || [],
    };
  } catch (error) {
    console.error("Failed to fetch pending notifications:", error);
    return { totalSize: 0, objectList: [] };
  }
};

export const rejectNotification = async ({ notificationId, rejectionReason }) => {
  return AHMIS.post(`${API_URL.notifications}/reject`, { notificationId, rejectionReason });
};

export const fetchSourceData = async (apiKey, sourceId) => {
  const baseUrl = API_URL[apiKey];
  if (!baseUrl) throw new Error(`API key ${apiKey} not found`);
  const response = await AHMIS.get(`${baseUrl}/${sourceId}`);
  return response.data?.data || response.data || {};
};
